import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function ViewCustomerPayment() {
  const navigate = useNavigate();
  const { id } = useParams(); // customer payment id
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    const fetchPayment = async () => {
      try {
        const rc_id = sessionStorage.getItem("rc_id");
        const center_name = sessionStorage.getItem("center_name");

        if (!rc_id || !center_name) {
          toast.error("❌ Missing Redemption Center details. Please log in again.");
          return;
        }

        const res = await axios.get(`/auth/redem-customer-payments/${id}`, {
          params: { rc_id, center_name },
        });

        setPayment(res.data);
      } catch (err) {
        console.error("Error fetching customer payment details:", err);
        toast.error("❌ Failed to load customer payment details");
      }
    };

    fetchPayment();
  }, [id]);

  if (!payment) {
    return <div className="p-6 text-gray-500 text-center">Loading payment details...</div>;
  }

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-8 bg-gray-50 flex justify-center items-center min-h-screen">
      <div className="bg-white max-w-5xl w-full mx-auto p-6 sm:p-8 rounded-2xl shadow-2xl">
        <h1 className="text-3xl font-extrabold text-center text-green-700 mb-10">
          Customer Payment Details
        </h1>

        <div className="grid gap-6">
          <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-3">
            <div className="inline-block bg-green-100 text-green-700 font-semibold px-4 py-1 rounded-full text-sm shadow-sm">
              {payment.cust_id || `PAY-${payment.id}`}
            </div>
            <div>
              <h2 className="text-xl font-semibold text-green-800">Payment Info</h2>
              <p className="text-sm text-gray-500">
                View detailed customer payment information
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
            <Info label="Customer ID" value={payment.cust_id} />
            <Info
              label="Customer Name"
              value={`${payment.first_name || ""} ${payment.last_name || ""}`}
            />
            <Info label="Customer Email" value={payment.email} />
            <Info label="Phone" value={payment.phone} />
            <Info label="Amount" value={`₹${payment.net_total || "-"}`} />
            <Info label="Payment Method" value={payment.payment_method} />
            <Info label="Payment Status" value={payment.paymentStatus || "-"} />

            <Info label=" Redemption Center Name" value={payment.center_name} />
            <Info label="RC ID" value={payment.rc_id} />
          </div>

          <div className="flex justify-end mt-5">
            <button
              onClick={() => navigate("/redem-customer-payments")}
              className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
            >
              Back to Payments
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

function Info({ label, value }) {
  return (
    <div className="text-gray-700">
      <span className="font-semibold">{label}:</span> {value || "-"}
    </div>
  );
}
